import React, { useContext, useEffect, useState } from "react";
import { DataContext } from "../../contexts/DataContext";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";
import styled from "styled-components";
import FormationEditor from "../Modals/FormationEditor";
import { Button } from "../../Theme/Hyper";
import SettingEditor from "../Modals/SettingEditor";

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 8px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;
export default function SettingsList() {
  const { getSettings } = useContext(DataContext);
  const [settings, setSettings] = useState();
  const [selectedSetting, setSelectedSetting] = useState();

  useEffect(() => {
    getData();
  }, []);

  function getData() {
    getSettings({}).then((data) => {
      setSettings(data);
    });
  }
  return (
    <>
      <Button
        style={{ width: "200px", margin: "1em" }}
        green
        onClick={() => {
          setSelectedSetting({
            name: "",
            value: "",
          });
        }}
      >
        Create New
      </Button>
      <Panel style={{ marginTop: "1em" }}>
        <PanelTitle title={"settings List"} />
        <PanelContent>
          <Table>
            <thead>
              <tr>
                <TH>ID</TH>
                <TH>Name</TH>
                <TH>Value</TH>
              </tr>
            </thead>
            <tbody>
              {settings &&
                settings.map((setting) => {
                  return (
                    <tr
                      onClick={() => {
                        setSelectedSetting(setting);
                      }}
                    >
                      <td>{setting._id}</td>
                      <td>{setting.name}</td>
                      <td>{setting.value}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </PanelContent>
      </Panel>
      {selectedSetting && (
        <SettingEditor
          setting={selectedSetting}
          selectSetting={(s) => {
            setSelectedSetting(s);
          }}
          onCancel={() => {
            setSelectedSetting();
          }}
          onSave={() => {
            setSelectedSetting();
            getData();
          }}
        />
      )}
    </>
  );
}
